import Http from './../http';

const prefix = '/user_fonts';

export const get = () => {
  return Http.authApi().get(`${prefix}`);
};

export const store = params => Http.authApi().post(`${prefix}`, params);

export const remove = font_id => Http.authApi().delete(`${prefix}/delete/${font_id}`);



// WEBPACK FOOTER //
// ./src/js/services/editor/userFont.js